/**
 * Simple singleton AbortController for agency changes
 * 
 * When the user changes agencies, we need to abort all pending requests
 * to prevent race conditions where old agency data overwrites new agency data.
 */

let currentAgencyController = null;

/**
 * Call this when the agency changes to abort all pending requests
 * @returns {AbortSignal} New signal for the new agency's requests
 */
export function onAgencyChange() {
    // Abort all pending requests for old agency
    if (currentAgencyController) {
        currentAgencyController.abort();
    }
    
    // Create new controller for new agency
    currentAgencyController = new AbortController();
    
    return currentAgencyController.signal;
}

/**
 * Get the current agency's abort signal for requests
 * @returns {AbortSignal} Signal to use for requests
 */
export function getAgencySignal() {
    if (!currentAgencyController) {
        currentAgencyController = new AbortController();
    }
    
    return currentAgencyController.signal;
}

/**
 * Check if the current signal is aborted
 * @returns {boolean}
 */
export function isAborted() {
    return currentAgencyController?.signal?.aborted || false;
}

